<div class="flex flex-col">
    @if (label()) {
        <span class="text-secondary card-text">{{ label() | translate }}</span>
    }
    <div class="pt-4 flex flex-row gap-6">
        @for (requester of requesterUsers(); track requester) {
            <tran-user-avatar [userDetails]="requester" />
        }
    </div>
</div>
